module.exports = __webpack_public_path__ + "static/app-icon-group-74a4cd400148632435d2210f934707ed.webp";